import { usePathname } from 'next/navigation';

import { AppName } from 'models';

import { useCurrentApp } from 'hooks/use-current-app';

const SHOW_CONTROLLER_BUTTONS_PATHS = ['/controller'];

export const useHeaderState = () => {
    const pathName = usePathname();
    const currentApp = useCurrentApp();

    const showControllerButtons = SHOW_CONTROLLER_BUTTONS_PATHS.some((path) => pathName?.startsWith(path));

    return {
        showResourceProNav: currentApp === AppName.REPLUS,
        showControllerButtons,
    };
};
